import React from "react";
import CustomDiv from "../../Shared/CustomDiv";
import { Carousel } from "react-responsive-carousel";
import Text from "../../Shared/Text";
import { Divider } from "@mui/material";
import classNames from "classnames";
import CustomButton from "../../Shared/CustomButton";
import { sliderListFn } from "../../Services/SliderList";
import { useMutation } from "react-query";
import { useState } from "react";
import { useEffect } from "react";
import { testimonialFn } from "../../Services/Testimonial";
import { bannerFn } from "../../Services/Banner";
import { allFiltersFn } from "../../Services/AllFilters/index,";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const [open, setOpen] = useState(null);
  const [data, setData] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [banners, setBanners] = useState([]);
  const [spices, setSpices] = useState([]);
  const handleActiveHover = (id) => {
    setOpen(id);
  };
  const handleCloseHover = () => {
    setOpen(null);
  };

  const { mutate } = useMutation(sliderListFn, {
    onSuccess: (response) => {
      setData(response.data.data);
    },
  });
  const { mutate: testimonial } = useMutation(testimonialFn, {
    onSuccess: (response) => {
      setTestimonials(response.data.data);
    },
  });

  const { mutate: banner } = useMutation(bannerFn, {
    onSuccess: (response) => {
      setBanners(response.data.data);
    },
  });
  useEffect(
    () => {
      mutate();
      testimonial();
      banner();
    },
    // eslint-disable-next-line
    []
  );
  const navigate = useNavigate();
  const { mutate: allFilters } = useMutation(allFiltersFn, {
    onSuccess: (response) => {
      setSpices(response.data.data.product_list);
    },
  });

  useEffect(
    () => {
      allFilters({
        category_id: 5,
        sub_category_id: "",
        brand_id: "",
        color_id: "",
        max_price: "",
        min_price: "",
        rating: "",
      });
    },
    // eslint-disable-next-line
    [""]
  );

  return (
    <CustomDiv className="">
      <Carousel
        autoPlay
        infiniteLoop
        showThumbs={false}
        className="testimonial-carousel"
      >
        {testimonials?.map((testimonial) => {
          return (
            <CustomDiv className="flex flex-col h-[600px] lg:h-64 gap-2 lg:flex-row gradient justify-center items-center lg:px-[20%] px-[4%] py-3 mx-3">
              <img
                src={testimonial.image}
                alt=""
                style={{ border: "5px solid black" }}
                className="rounded-full !w-52 !p-2 !border-2 !border-white"
              />

              <CustomDiv className="flex flex-col text-white">
                <Text className="text-xl font-bold text-center">
                  {testimonial.name}
                </Text>
                <Text className="lg:pr-[10%] text-center">
                  {testimonial.message}
                </Text>
              </CustomDiv>
            </CustomDiv>
          );
        })}
      </Carousel>
      {/* <Carousel autoPlay showThumbs={false} className="shubhga-carousel">
        {data?.map((slider) => {
          return (
            <div key={slider.id}>
              <img alt="" src={slider.image} className="relative lg:h-auto" />
            </div>
          );
        })}
      </Carousel>

      <CustomDiv className="flex flex-col-reverse gap-10 justify-center items-center my-4 bg-[#F2F8F9] p-4 ">
        {banners?.map((banner) => {
          return (
            <div className="flex flex-col gap-2 lg:gap-5">
              <Divider textAlign="left" className="font-bold lg:text-xl">
                {banner.category}
              </Divider>
              <div className="flex gap-2 lg:gap-10">
                {banner?.banners?.map((i) => {
                  return (
                    <div
                      className="flex gap-10 cursor-pointer"
                      onClick={() =>
                        navigate("/all-products", {
                          state: {
                            from: "category",
                            category: i.category,
                          },
                        })
                      }
                    >
                      <img
                        src={i.image}
                        alt=""
                        className="rounded lg:w-[680px]"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </CustomDiv> */}
      {/* <CustomDiv className="px-[4%] lg:px-[8%] bg-[#F2F8F9]">
        <CustomDiv className="flex gap-4 my-5 py-1 w-full hide-scroll px-4 overflow-x-auto">
          {spices?.map((product) => {
            return (
              <CustomDiv
                className="rounded-md h-fit w-[250px] duration-200 shadow bg-white cursor-pointer a"
                onClick={() => navigate(`/product/${product?.id}`)}
              >
                <span className="centerdiv">
                  <img src={product.image} alt="" className="h-52 relative" />
                </span>
                <CustomDiv className="flex flex-col justify-between p-4 space-y-2">
                  <CustomDiv className="space-y-2">
                    <Text className="text-lg class-name font-semibold">
                      {product.title}
                    </Text>
                  </CustomDiv>
                  <Text className="text-sm uppercase">
                    {product.main_category}
                  </Text>
                  <CustomDiv className="flex items-center gap-3">
                    <Text className="">₹{product.price}</Text>
                    {product.discount_percent !== "0.0" ? (
                      <Text className="font-bold text-xl">
                        ₹{product.actual_price}
                      </Text>
                    ) : null}
                    <Text className="text-green-600">
                      {product.discount_percent !== "0.0"
                        ? `(${product.discount_percent?.split(".0")})%`
                        : null}
                    </Text>
                  </CustomDiv>
                  <span className="flex gap-4"> */}
      {/* <IconButton
                      color="primary"
                      variant="solid"
                      // onClick={(event) => {
                      //   product.whishlist_status === "yes" ? (
                      //     <>{` ${enqueueSnackbar(
                      //       "Product is already in wishlist"
                      //     )}
                      //       ${event.stopPropagation()}`}</>
                      //   ) : (
                      //     handleWishList(product?.variant_id, event)
                      //   );
                      // }}
                      className="!rounded"
                    >
                      {product.whishlist_status !== "No" ? (
                        <Favorite />
                      ) : (
                        <FavoriteBorder />
                      )}
                    </IconButton> */}
      {/* <CustomButton
                    type="button"
                    className="!rounded w-full"
                    onClick={(event) =>
                      localStorage.getItem("shubhgatoken")
                        ? addToCart(event, product.product_id)
                        : handleLogin()
                    }
                  >
                    Add To Cart
                  </CustomButton> */}
      {/* </span>
                </CustomDiv>
              </CustomDiv>
            );
          })}
        </CustomDiv>
      </CustomDiv>

      <CustomDiv className="flex flex-col justify-center items-center gap-1 my-10">
        <Text className="text-center text-xl font-semibold">
          Discount On Every Single Item On Our Site.
        </Text>
        <Text className="text-center text-blue-800 lg:text-4xl text-xl font-bold">
          <span className="text-blue-400 px-2 !font-semibold">
            OMG! JUST LOOK AT THE
          </span>
          GREAT DEALS!
        </Text>
        <span className="p-2 my-3 border-4 border-[#D32F2F] border-dashed rounded-full mx-3">
          <Text className="p-3 font-semibold text-center rounded-full text-white lg:text-xl gradient">
            HOW DOES IT FEEL, WHEN YOU SEE GREAT DISCOUNT DEALS FOR EACH
            PRODUCT?
          </Text>
        </span>
      </CustomDiv> */}
      {/* <CustomDiv className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 px-3 my-2">
        {[
          {
            src: "https://images-static.nykaa.com/media/catalog/product/a/6/a6bf37c8906087770671aw__1_.jpg",
            name: "Facewash",
          },
          {
            src: "https://images-static.nykaa.com/media/catalog/product/e/1/e1f91e58906009451060_1.jpg",
            name: "Toner",
          },
          {
            src: "https://images-static.nykaa.com/media/catalog/product/6/3/6390dabNYMATRIX00081_1.jpg",
            name: "Serum",
          },
        ].map((item) => {
          return (
            <ImageListItem
              key={item.name}
              component={Paper}
              elevation={2}
              className="cursor-pointer"
            >
              <img
                src={item.src}
                srcSet={item.src}
                alt=""
                loading="lazy"
                className=""
              />
              <ImageListItemBar
                title={item.name}
                subtitle={
                  "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eum dolore, quam a qui accusamus, inventore sint laboriosam ea, praesentium impedit molestiae tempore nobis? Qui dolorum illo minima soluta nostrum maxime?"
                }
                className="!text-xl"
              />
            </ImageListItem>
          );
        })}
      </CustomDiv> */}

      <Divider />
      {/* <CustomDiv className="flex flex-col justify-center items-center px-[8%]">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="wrapped label tabs example"
          className="tab"
        >
          <Tab value="1" label="FASHION" />
          <Tab value="2" label="ELECTRONIC " />
          <Tab value="3" label="FOOTWARE" />
          <Tab value="4" label="SPORTS" />
          <Tab value="5" label="TOYS" />
          <Tab value="6" label="BOOKS" />
        </Tabs>
        <CustomDiv className="grid grid-cols-5 w-full p-4 gap-5">
          {[
            {
              id: 1,
              name: "ONION ULTIMATE HAIR CARE COMBO KIT",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/7f0c720d-09cf-4768-8119-a0e0fb8a7af9/onionkit.jpg?v=1674963892",
            },
            {
              id: 2,
              name: "VITAMIN C FACE ULTIMATE KIT FOR SKIN",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/9cbe02cb-be07-4c01-8e26-049c510786b3/vitaminccombo_1024x1024_1024x1024_1024x1024_20ccc6d4-93c4-4a92-8162-eb5a8e435f9e.jpg?v=1655835052",
            },
            {
              id: 3,
              name: "UBTAN ULTIMATE SKIN CARE COMBO KIT",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/0f12d28e-7ec8-44e4-85ce-6e01005aebbd/render_front_1.jpg?v=1662027056",
            },
            {
              id: 4,
              name: "ONION HAIR OIL FOR HAIR FALL CONTROL",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/e5bb94cb-2142-4fb0-9951-f86f846f362f/Onion-hair-oil-200-ml-d-shape-4.jpg?v=1674825043",
            },
            {
              id: 5,
              name: "ONION SHAMPOO FOR HAIR GROWTH AND HAIR",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/6e5f1bd2-78d9-4ca7-9fe2-124491544e43/Onion-shampoo-1.jpg?v=1675063533",
            },
          ].map((item) => {
            return (
              <Card
                id={item.id}
                onMouseEnter={() => handleActiveHover(item.id)}
                onMouseLeave={() => handleCloseHover(item.id)}
                elevation={2}
                className="flex flex-col !rounded-none w-64"
              >
                <CustomDiv className="!rounded-none flex gap-3 items-end justify-center h-72">
                  {[
                    <ShoppingCartOutlined />,
                    <FavoriteBorderOutlined />,
                    <VisibilityOutlined />,
                    <AutorenewOutlined />,
                  ].map((icon) => {
                    return (
                      <>
                        <img
                          src={item.src}
                          alt=""
                          className="absolute h-[285px] w-[253px]"
                        />
                        <span
                          className={classNames(
                            "h-10 w-10 relative transition-all delay-150 duration-500 border-blue-400 border border-opacity-0 hover:!border-opacity-100 z-50 flex justify-center cursor-pointer items-center bg-white",
                            open === item.id ? "scale-100 " : "scale-0"
                          )}
                        >
                          {icon}
                        </span>
                      </>
                    );
                  })}
                </CustomDiv>
                <CustomDiv className="bg-white p-3">
                  <Text className="text-center font-semibold">{item.name}</Text>
                  <Text className="text-center font-semibold">₹848.30</Text>
                </CustomDiv>
              </Card>
            );
          })}
        </CustomDiv>
      </CustomDiv> */}
      {/* <CustomDiv className="mx-3 object-contain my-2 flex flex-col gap-4 justify-center items-center py-5 h-[250px]  bg-[url('https://themes.pixelstrap.com/bigdeal/assets/images/layout-2/collection-banner/7.jpg')]">
        <Text className="text-3xl text-gray-500">Save Up To 30% Off</Text>
        <Text className="text-blue-400 font-bold text-center text-6xl">
          Women <span className="!text-blue-800 !font-semibold">fashion</span>
        </Text>
        <CustomButton size="large" className="!p-3 !px-5">
          Shop Now
        </CustomButton>
      </CustomDiv> */}
      {/* <CustomDiv className="flex lg:flex-row flex-col gap-5 justify-between items-center px-[12%] gradient py-10 mx-3">
        <span className="text-white text-center">
          <Text className="font-semibold lg:text-2xl text-xl">
            SAVE UP TO 30% TO 40% OFF
          </Text>
          <Text className="font-bold lg:text-3xl text-xl">
            OMG! JUST LOOK AT THE GREAT DEALS!
          </Text>
        </span>
        <CustomButton className="!bg-white !p-3 !px-8 !text-black !rounded-full">
          View More
        </CustomButton>
      </CustomDiv> */}
      {/* <CustomDiv className="grid grid-cols-6 justify-center items-center px-[8%] my-3 bg-blue-800 h-60 mx-3">
        {[
          {
            name: "Bag",
            src: "https://bigdeal-git-main-pixelstrapthemes.vercel.app/images/layout-1/rounded-cat/1.png",
          },
          {
            name: "Tools",
            src: "https://bigdeal-git-main-pixelstrapthemes.vercel.app/images/layout-1/rounded-cat/2.png",
          },
          {
            name: "Grocery",
            src: "https://bigdeal-git-main-pixelstrapthemes.vercel.app/images/layout-1/rounded-cat/3.png",
          },
          {
            name: "Camera",
            src: "https://bigdeal-git-main-pixelstrapthemes.vercel.app/images/layout-1/rounded-cat/4.png",
          },
          {
            name: "Shoes",
            src: "https://bigdeal-git-main-pixelstrapthemes.vercel.app/images/layout-1/rounded-cat/5.png",
          },
          {
            name: "Cosmetic",
            src: "https://bigdeal-git-main-pixelstrapthemes.vercel.app/images/layout-1/rounded-cat/5.png",
          },
        ].map((item) => {
          return (
            <span className="flex flex-col items-center justify-center gap-4">
              <img src={item.src} alt="" className="p-1 border rounded-full" />
              <Text className="text-center text-xl font-semibold text-white hover:bg-blue-400 transition-all duration-700 rounded-full p-2 px-6 cursor-pointer">
                {item.name}
              </Text>
            </span>
          );
        })}
      </CustomDiv> */}
      {/* <CustomDiv className="bg-[rgb(242,251,254)] whitespace-nowrap overflow-x-auto hide-scroll m-3 flex gap-5 px-[8%]">
        {[
          "10% OFF",
          "Only $49",
          "Under @150",
          "Save Money",
          "80% OFF",
          "Free Shipping",
          "$79 Cashback",
          "Extra 10% OFF",
          "On Sale",
          "Free Shipping",
          "$79 Cashback",
          "Extra 10% OFF",
          "On Sale",
        ].map((item) => {
          return (
            <span className="flex justify-center items-center h-20 hover:bg-blue-300 hover:text-white transition-all duration-200 ease-linear p-3 px-5">
              <Text className="text-xl font-bold">{item}</Text>
            </span>
          );
        })}
      </CustomDiv> */}
      {/* <CustomDiv className="flex flex-col justify-center items-center">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="wrapped label tabs example"
          className="tab"
        >
          <Tab className="" value="1" label="NEW PRODUCT" />
          <Tab className="" value="2" label="FEATURE PRODUCTS" />
          <Tab className="" value="3" label="BEST SELLERS" />
          <Tab className="" value="4" label="ON SALE" />
        </Tabs>
        <CustomDiv className="grid grid-cols-4 gap-5 my-3">
          {[1, 2, 3, 4].map(() => {
            return (
              <CustomDiv className="flex flex-col gap-6 bg-[#EEF3F4] p-5">
                {[1, 2, 3].map(() => {
                  return (
                    <CustomDiv className="flex items-center justify-center gap-10">
                      <img
                        src="https://cdn3.mydukaan.io/app/image/318x318/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/9af2e3f2-8fe9-4d60-8f65-aeffc7628c8c/03_64ab3aea-274d-4617-bb40-5ed49eab190d.jpg?v=1676533879"
                        alt=""
                        className="w-24"
                      />
                      <span>
                        <Text className="font-bold">
                          10 IN 1 ACTIVE HAIR OIL
                        </Text>
                        <Text>₹599.00</Text>
                      </span>
                    </CustomDiv>
                  );
                })}
              </CustomDiv>
            );
          })}
        </CustomDiv>
      </CustomDiv> */}
      {/* <CustomDiv className="flex justify-center my-4 bg-[#F2F8F9] gap-5 p-4 lg:px-[8%]">
        {banners?.slice(0, 2)?.map((banner) => {
          return (
            <img src={banner.banners[0].image} alt="" className="rounded " />
          );
        })}
      </CustomDiv> */}
      {/* <CustomDiv className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 py-10 bg-[#F2F8F9] gap-5 p-4 lg:px-[8%]">
        <CustomDiv className="flex items-center justify-between bg-white p-3">
          <img
            src="https://images-static.nykaa.com/media/catalog/product/6/2/62ec68927278_S1_8901030773563.jpg?tr=w-344,h-344,cm-pad_resize"
            alt=""
            className="w-1/2"
          />
          <span className="w-1/2">
            <Text className="text-lg font-semibold">Faacewash</Text>
            <Text className="">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Blanditiis est qui sint neque.
            </Text>
            <Text>
              <span className="line-through text-red-600 px-1">₹699</span>
              <span className="text-blue-600 px-1">₹499</span>
            </Text>
          </span>
        </CustomDiv>
        <CustomDiv className="flex items-center justify-between bg-white p-3">
          <img
            src="https://images-static.nykaa.com/media/catalog/product/4/1/41d74f8BRILL00000014.jpg"
            alt=""
            className="w-1/2"
          />
          <span className="w-1/2">
            <Text className="text-lg font-semibold">Toner</Text>
            <Text className="">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Blanditiis est qui sint neque.
            </Text>
            <Text>
              <span className="line-through text-red-600 px-1">₹699</span>
              <span className="text-blue-600 px-1">₹499</span>
            </Text>
          </span>
        </CustomDiv>
        <CustomDiv className="flex items-center justify-between bg-white p-3">
          <img
            src="https://images-static.nykaa.com/media/catalog/product/2/c/2c828df8902979024129_2.jpg"
            alt=""
            className="w-1/2"
          />
          <span className="w-1/2">
            <Text className="text-lg font-semibold">Serum</Text>
            <Text className="">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Blanditiis est qui sint neque.
            </Text>
            <Text>
              <span className="line-through text-red-600 px-1">₹699</span>
              <span className="text-blue-600 px-1">₹499</span>
            </Text>
          </span>
        </CustomDiv>
      </CustomDiv> */}
      {/* <Text className="text-xl my-10 font-bold text-center">
        TODAY'S HOT DEAL
      </Text>
      <CustomDiv className="bg-[#EEF3F4] flex  gap-3 m-3 px-[6%]">
        <CustomDiv className="w-3/4 flex items-center gap-4 p-7">
          <img
            src="https://cdn3.mydukaan.io/app/image/500x500/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/e614e55d-66fd-4a17-98d6-e0ddfe6bc31b/image.png"
            alt=""
            className="w-72 h-96"
          />
          <CustomDiv className="flex flex-col gap-3 py-3">
            <Text className="text-xl font-semibold">GREEN TEA FACE WASH</Text>
            <Text className="selection:bg-black selection:text-white">
              It is a long established fact that a reader. It is a long
              established fact that a reader.It is a long established fact that
              a reader. It is a long established fact that a reader.
            </Text>
            <Text className="">
              <span>$85.30</span>
              <span className="mx-4 line-through">90.00</span>
            </Text>
            <span className="flex gap-4 items-center">
              <span className="flex flex-col py-4 px-3 bg-white">
                <Text>-752</Text>
                <Text>Days</Text>
              </span>
              <span className="flex flex-col py-4 px-3 bg-white">
                <Text>-17</Text>
                <Text>Hrs</Text>
              </span>
              <span className="flex flex-col py-4 px-3 bg-white">
                <Text>-54</Text>
                <Text>Min</Text>
              </span>
              <span className="flex flex-col py-4 px-3 bg-white">
                <Text>-35</Text>
                <Text>Sec</Text>
              </span>
            </span>
            <CustomButton className="w-fit !rounded">Shop Now</CustomButton>
          </CustomDiv>
          <CustomDiv className="flex flex-col h-[450px] overflow-y-auto gap-3 hide-scroll">
            {[1, 2, 3, 4, 5, 6.7, 8, 9].map((item) => {
              return (
                <img
                  src={`https://source.unsplash.com/random/${item}`}
                  alt=""
                  className="cursor-pointer border-2 w-36 border-opacity-0 border-blue-400 hover:!border-opacity-100"
                />
              );
            })}
          </CustomDiv>
        </CustomDiv>
        <CustomDiv className="w-1/4 flex flex-col p-5">
          <Text className="text-2xl font-bold">NEW PRODUCTS</Text>
          {[5, 6, 7].map((item) => {
            return (
              <CustomDiv className="flex items-center justify-center gap-5 m-4">
                <img
                  src={`https://source.unsplash.com/random/${item}`}
                  alt=""
                  className="w-20 h-20"
                />
                <span>
                  <Text className="font-bold">10 IN 1 ACTIVE HAIR OIL</Text>
                  <Text>₹599.00</Text>
                </span>
              </CustomDiv>
            );
          })}
          <CustomButton variant="text" className="w-fit">
            View More
          </CustomButton>
        </CustomDiv>
      </CustomDiv> */}

      {/* <Text className="text-xl font-bold my-10 text-center">
        SPECIAL PRODUCTS
      </Text>
      <CustomDiv className="px-[8%]">
        <Slider {...settings} className="home-slider">
          {[
            {
              id: 1,
              name: "ONION ULTIMATE HAIR CARE COMBO KIT",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/7f0c720d-09cf-4768-8119-a0e0fb8a7af9/onionkit.jpg?v=1674963892",
            },
            {
              id: 2,
              name: "VITAMIN C FACE ULTIMATE KIT FOR SKIN",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/9cbe02cb-be07-4c01-8e26-049c510786b3/vitaminccombo_1024x1024_1024x1024_1024x1024_20ccc6d4-93c4-4a92-8162-eb5a8e435f9e.jpg?v=1655835052",
            },
            {
              id: 3,
              name: "UBTAN ULTIMATE SKIN CARE COMBO KIT",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/0f12d28e-7ec8-44e4-85ce-6e01005aebbd/render_front_1.jpg?v=1662027056",
            },
            {
              id: 4,
              name: "ONION HAIR OIL FOR HAIR FALL CONTROL",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/e5bb94cb-2142-4fb0-9951-f86f846f362f/Onion-hair-oil-200-ml-d-shape-4.jpg?v=1674825043",
            },
            {
              id: 5,
              name: "ONION SHAMPOO FOR HAIR GROWTH AND HAIR",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/6e5f1bd2-78d9-4ca7-9fe2-124491544e43/Onion-shampoo-1.jpg?v=1675063533",
            },
            {
              id: 1,
              name: "ONION ULTIMATE HAIR CARE COMBO KIT",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/7f0c720d-09cf-4768-8119-a0e0fb8a7af9/onionkit.jpg?v=1674963892",
            },
            {
              id: 2,
              name: "VITAMIN C FACE ULTIMATE KIT FOR SKIN",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/9cbe02cb-be07-4c01-8e26-049c510786b3/vitaminccombo_1024x1024_1024x1024_1024x1024_20ccc6d4-93c4-4a92-8162-eb5a8e435f9e.jpg?v=1655835052",
            },
            {
              id: 3,
              name: "UBTAN ULTIMATE SKIN CARE COMBO KIT",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/0f12d28e-7ec8-44e4-85ce-6e01005aebbd/render_front_1.jpg?v=1662027056",
            },
            {
              id: 4,
              name: "ONION HAIR OIL FOR HAIR FALL CONTROL",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/e5bb94cb-2142-4fb0-9951-f86f846f362f/Onion-haafir-oil-200-ml-d-shape-4.jpg?v=1674825043",
            },
            {
              id: 5,
              name: "ONION SHAMPOO FOR HAIR GROWTH AND HAIR",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/6e5f1bd2-78d9-4ca7-9fe2-124491544e43/Onion-shampoo-1.jpg?v=1675063533",
            },
            {
              id: 2,
              name: "VITAMIN C FACE ULTIMATE KIT FOR SKIN",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/9cbe02cb-be07-4c01-8e26-049c510786b3/vitaminccombo_1024x1024_1024x1024_1024x1024_20ccc6d4-93c4-4a92-8162-eb5a8e435f9e.jpg?v=1655835052",
            },
            {
              id: 3,
              name: "UBTAN ULTIMATE SKIN CARE COMBO KIT",
              src: "https://cdn3.mydukaan.io/app/image/329x329/?url=https://dukaan-core-file-service.s3.ap-southeast-1.amazonaws.com/upload_file_service/asg/0f12d28e-7ec8-44e4-85ce-6e01005aebbd/render_front_1.jpg?v=1662027056",
            },
          ].map((item) => {
            return (
              <Card
                onMouseEnter={handleActiveHover}
                onMouseLeave={handleCloseHover}
                className="flex flex-col !rounded-none w-48 m-2"
              >
                <CustomDiv className="!rounded-none flex gap-3 items-end justify-center h-72">
                  {[
                    <ShoppingCartOutlined />,
                    <FavoriteBorderOutlined />,
                    <VisibilityOutlined />,
                    <AutorenewOutlined />,
                  ].map((icon) => {
                    return (
                      <>
                        <img
                          src={item.src}
                          alt=""
                          className="absolute h-[285px] px-2 w-[240px]"
                        />
                        <span
                          className={classNames(
                            "h-10 w-10 relative z-50 border-blue-400 border border-opacity-0 hover:!border-opacity-100 flex justify-center cursor-pointer items-center bg-white",
                            open
                              ? "block transition-all duration-500"
                              : "hidden transition-all duration-500"
                          )}
                        >
                          {icon}
                        </span>
                      </>
                    );
                  })}
                </CustomDiv>
                <CustomDiv className="bg-white p-3">
                  <Text className="text-center font-semibold">{item.name}</Text>
                  <Text className="text-center font-semibold">₹848.30</Text>
                </CustomDiv>
              </Card>
            );
          })}
        </Slider>
      </CustomDiv> */}
      {/* <CustomDiv className="flex overflow-x-auto hide-scroll m-3">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map((item) => {
          return (
            <CustomDiv className="lg:w-1/2 h-80" key={item}>
              <img
                src={`https://source.unsplash.com/random/900×700/?food/${item}`}
                alt=""
                className="relative w-[295px] h-[295px] cursor-pointer"
              />
              <span
                onMouseEnter={() => handleActiveHover(item)}
                onMouseLeave={() => handleCloseHover(item)}
                className="relative overflow-hidden flex cursor-pointer justify-center items-center bottom-[19rem] pb-[108px] p-24 bg-white bg-opacity-0 hover:bg-opacity-20"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  fill="currentColor"
                  class="bi bi-instagram"
                  viewBox="0 0 16 16"
                  className={classNames(
                    "text-[#00BAF2] transition-all duration-700",
                    open === item
                      ? "scale-100 rotate-0"
                      : "scale-0 rotate-[-270deg]"
                  )}
                >
                  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                </svg>
              </span>
            </CustomDiv>
          );
        })}
      </CustomDiv> */}
    </CustomDiv>
  );
};

export default LandingPage;
